<template>
  <div class="card form-sign-in">
    <div class="card-header">{{t('Register')}}</div>
    <div class="card-body text-center" v-if="loading === true">
      <loading/>
      <span class="d-block mt-2">{{t('Creating your account')}}</span>
    </div>
    <div class="card-body" v-if="loading === false && finished === false">
      <span class="info" v-html="introText"></span>
      <titan-form ref="loginForm"
                  :schema="schema"
                  :renderInCard="false"
                  :model="formData"
                  @saveData="sendForm()"
      />

      <div v-for="(condition, key) in conditions" class="mb-3 condition-line">
        <label class="conditions-checkbox">
          <input type="checkbox" v-model="conditionModel[key]">
        </label>
        <div class="d-inline-block conditions-text">
          <span class="conditions-label">{{condition.label}}</span>
          <span v-if="condition.clickText !== undefined" @click="showConditions = true; conditionKey = key"
                class="c-pointer text-primary"> {{condition.clickText}}</span>
          <span v-if="condition.required === undefined || condition.required === true" class="text-danger">*</span>

        </div>
        <div v-if="isRequired(condition) && conditionModel[key] === false && showErrors === true"
             class="conditions-error"
        >
          {{t('fieldIsRequired')}}
        </div>
      </div>


      <button type="button" class="btn btn-primary mt-1 btn-block" @click="sendForm()">
        {{t('Register')}}
      </button>
    </div>
    <div class="card-body text-center" v-if="loading === false && finished === true">
      <font-awesome-icon icon="check-circle" size="2x" class="text-success"/>
      <br>
      <strong>{{t('Account was created.')}}</strong>
      <br/>
      {{t('Please check your mailbox & activate your profile')}}
    </div>


    <b-modal v-model="showConditions" :title="selectedCondition === null ? '' : selectedConditionTitle">
      <div v-if="selectedCondition !== null" v-html="selectedCondition.text"></div>
      <template slot="modal-footer">
        <button type="button"
                class="btn btn-success"
                @click="showConditions = false; conditionModel[conditionKey] = true"
        >
          {{t('Accept')}}
        </button>
        <button type="button" class="mr-auto btn btn-danger" @click="showConditions = false">
          {{t('Decline')}}
        </button>
      </template>
    </b-modal>
  </div>
</template>
<script>
    import TitanForm from '../../Form/Form'
    import VueFormGenerator from "vue-form-generator";
    import Loading from '../../Components/loading';

    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faCheckCircle} from '@fortawesome/free-solid-svg-icons'

    library.add(faCheckCircle);

    export default {
        props: {
            formFields: {
                type: Array,
                required: false,
                default: () => {
                    return [
                        {
                            type: 'input',
                            inputType: 'text',
                            label: this.t('Firstname'),
                            model: 'firstname',
                            required: true,
                            validator: VueFormGenerator.validators.required
                        }, {
                            type: 'input',
                            inputType: 'text',
                            label: this.t('Lastname'),
                            model: 'lastname',
                            required: true,
                            validator: VueFormGenerator.validators.required
                        }, {
                            type: 'input',
                            inputType: 'text',
                            label: this.t('Login (e-mail)'),
                            model: 'login',
                            required: true,
                            validator: VueFormGenerator.validators.email
                        }, {
                            type: 'input',
                            inputType: 'password',
                            label: this.t('Password'),
                            model: 'password',
                            required: true,
                            max: 40,
                            min: 6,
                            validator: VueFormGenerator.validators.string,
                        }
                    ]
                }
            },
            registration: {
                type: Function,
                required: true,
            },
            conditions: {
                type: Array,
                required: false,
                default: () => {
                    return [];
                }
            },
            introText: {
                type: String,
                required: false,
                default: ''
            }
        },
        components: {
            Loading,
            TitanForm
        },
        computed: {
            selectedConditionTitle() {
                if (this.conditions[this.conditionKey] !== undefined) {
                    let selected = this.conditions[this.conditionKey];
                    return selected.title !== undefined ? selected.title : selected.label
                }
                return ''
            },
            selectedCondition() {
                return this.conditions[this.conditionKey] === undefined ? null : this.conditions[this.conditionKey];
            }
        },
        created() {
            this.schema[0].fields = this.formFields;

            this.conditions.forEach((item, key) => {
                this.conditionModel[key] = item.default === undefined ? false : item.default;
            });

        },
        methods: {
            isRequired(condition) {
                return condition.required === undefined || condition.required === true;
            },
            sendForm() {
                this.isValidConditions();
                this.conditions.forEach((item, key) => {
                    let condModelKey = item.model;
                    this.formData[condModelKey] = this.conditionModel[key] ? 1 : 0;
                })
                if (this.$refs.loginForm.isValid() === true && this.isValidConditions() === true) {
                    this.loading = true;
                    this.registration(this.formData).then(response => {
                        this.finished = true;
                        this.loading = false;
                        this.$emit('registered');
                    }).catch(error => {
                        this.loading = false;
                        this.$emit('notRegistered', error);
                    });
                }
            },
            isValidConditions() {
                let valid = true;
                this.conditions.forEach((item, key) => {
                    const isRequired = item.required === undefined || item.required === true;
                    if (isRequired && this.conditionModel[key] === false) {
                        this.showErrors = true;
                        valid = false;
                    }
                });
                return valid;
            }
        },
        data() {
            return {
                finished: false,
                loading: false,
                schema: [
                    {
                        name: '',
                        type: 'main',
                        fields: [],
                    }
                ],
                showConditions: false,
                showErrors: false,
                conditionKey: null,
                conditionModel: {},
                formData: {
                    login: '',
                    password: '',
                    conditions: false,
                }
            }
        }
    }
</script>
<style lang="scss">
  .form-sign-in {
    .info {
      display:block;
      font-size:0.9em;
      color:gray;
      padding-bottom:10px;
    }
    .titan-form-block {
      margin-bottom: 0;
    }

    .conditions-error {
      display: block;
      padding-left: 17px;
      padding-top: 0px;
      margin-top: -8px;
      font-weight: 600;
      color: #f00;
      font-size: 0.8em;
    }

    .forgotten-password {
      margin-top: -5px;
      text-align: right;
      margin-bottom: 15px;

      a {
        color: #8e8e8e;
        font-size: 15px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/core/Components/User/Registration.vue